<div class="title">
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.TITLE' | translate }}
</div>

<div class="main-content">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.HOW_DOES_IT_WORK' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ol type="1" class="instructions-list">
        <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_1' | translate }}</li>
        <li *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_2_SMB_CONTEXT' | translate }}
        </li>
        <li *ngIf="automationContext === context.AUTOMATION_CONTEXT_PARTNER">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_2_PARTNER_CONTEXT' | translate }}
        </li>
        <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_3' | translate }}</li>
        <li *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_4_SMB_CONTEXT' | translate }}
        </li>
        <li *ngIf="automationContext === context.AUTOMATION_CONTEXT_PARTNER">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_4_PARTNER_CONTEXT' | translate }}
        </li>
        <div class="id-section">
          <div class="id-name">
            <ng-container *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB">{{
              'AUTOMATIONS.COMMON.ACCOUNT_ID' | translate
            }}</ng-container>
            <ng-container *ngIf="automationContext === context.AUTOMATION_CONTEXT_PARTNER">{{
              'AUTOMATIONS.COMMON.PARTNER_ID' | translate
            }}</ng-container>
          </div>
          <div class="id" (click)="copyText(automation.namespace)">{{ automation.namespace }}</div>
          <mat-icon class="copy-icon" (click)="copyText(automation.namespace)">content_copy</mat-icon>
        </div>
        <li>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.ZAPIER_TRIGGER.INSTRUCTIONS_5' | translate }}</li>
        <div class="id-section">
          <div class="id-name">{{ 'AUTOMATIONS.COMMON.AUTOMATION_ID' | translate }}</div>
          <div class="id" (click)="copyText(automation.id)">{{ automation.id }}</div>
          <mat-icon class="copy-icon" (click)="copyText(automation.id)">content_copy</mat-icon>
        </div>
      </ol>
    </mat-expansion-panel>
  </mat-accordion>
</div>
